// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipaySquareFilledSvg from "@fishx/icons-svg/es/asn/AlipaySquareFilled";
import FishxIcon from '../components/FishxIcon';

var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipaySquareFilledSvg
  }));
};

AlipaySquareFilled.displayName = 'AlipaySquareFilled';
export default React.forwardRef(AlipaySquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlipaySquareFilled.js
// module id = 1967
// module chunks = 0